module.exports = __webpack_public_path__ + "media/images/talent/flow02-baed0353680aeffaaf77a8fd63175e10.png";